import * as React from "react";

const TransactionsIconSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill="#F8FAFC"
            d="M14 30a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 11 27v-3h3V10l1.5 1.5L17 10l1.5 1.5L20 10l1.5 1.5L23 10l1.5 1.5L26 10l1.5 1.5L29 10v17q0 1.25-.875 2.125A2.9 2.9 0 0 1 26 30zm12-2q.424 0 .712-.288A.97.97 0 0 0 27 27V13H16v11h9v3q0 .424.288.712.287.288.712.288m-9-11v-2h6v2zm0 3v-2h6v2zm8-3a.97.97 0 0 1-.712-.287A.97.97 0 0 1 24 16q0-.424.288-.713A.97.97 0 0 1 25 15q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 25 17m0 3a.97.97 0 0 1-.712-.288A.97.97 0 0 1 24 19q0-.424.288-.712A.97.97 0 0 1 25 18q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 25 20m-11 8h9v-2H13v1q0 .424.287.712.288.288.713.288m-.963 0v-2z"
        ></path>
    </svg>
);

export default TransactionsIconSVG;
